import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "favourite-panel favourite-panel--empty" }
const _hoisted_2 = { class: "favourite-panel__filters" }
const _hoisted_3 = { class: "favourite-panel__body" }
const _hoisted_4 = { class: "favourite-panel__group-title" }
const _hoisted_5 = { class: "favourite-panel__group-list" }
const _hoisted_6 = { class: "favourite-panel__body-item-number" }
const _hoisted_7 = { class: "favourite-panel__body-item-text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "favourite-panel__body-item-text-description" }
const _hoisted_10 = {
  key: 0,
  class: "favourite-panel__body-empty"
}
const _hoisted_11 = {
  key: 1,
  class: "favourite-panel__empty"
}

import { computed, onMounted, ref } from "vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { Favourite, favouritesStore } from "@/store/favourites";
import { escapeHtml, highlightSearchText } from "@/utils/textHelpers";
import { orderBy } from "lodash";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatFavouritePanel',
  setup(__props) {

const route = useRoute();
const store = favouritesStore();
const favourites = computed(() => store.favouritesList);
const sortType = ref<"asc" | "desc" | null>(null);
const showClients = ref(true);
const showProjects = ref(true);
const searchText = ref("");
const hoveredRemoveFavourite = ref<Favourite | null>(null);

const filteredFavourites = computed(() => {
  if (!favourites.value) return null;

  const normalizedSearchText = searchText.value.trim().toLowerCase();
  let modifiedFavourites = favourites.value.filter((favourite) => {
    const name =
      favourite.Type === 0
        ? favourite.Client?.Name
        : favourite.Project?.Name;

    return (name ?? "").toLowerCase().includes(normalizedSearchText);
  });

  if (!showClients.value) {
    modifiedFavourites = modifiedFavourites.filter(
      (favourite) => favourite.Type !== 0,
    );
  }

  if (!showProjects.value) {
    modifiedFavourites = modifiedFavourites.filter(
      (favourite) => favourite.Type !== 1,
    );
  }

  return sortType.value
    ? orderBy(
        modifiedFavourites,
        ["Type", "Title"],
        [sortType.value, sortType.value],
      )
    : [...modifiedFavourites]
});

const favouriteGroups = computed(() => {
  const filtered = filteredFavourites.value ?? [];

  const groups = [
    ...(showProjects.value
      ? [
          {
            type: 1,
            titleKey: "projects_label",
            items: filtered.filter((item) => item.Type === 1),
          },
        ]
      : []),
    ...(showClients.value
      ? [
          {
            type: 0,
            titleKey: "clients_label",
            items: filtered.filter((item) => item.Type === 0),
          },
        ]
      : []),
  ];

  return groups.filter((group) => group.items.length > 0);
});

const changeFavouriteSort = () => {
  switch (sortType.value) {
    case "asc":
      sortType.value = "desc";
      return;
    case "desc":
      sortType.value = null;
      return;
    default:
      sortType.value = "asc";
      return;
  }
};

const getFavouriteName = (favourite: Favourite) => {
  const name =
    favourite.Type === 0
      ? (favourite.Client?.Name ?? "")
      : (favourite.Project?.Name ?? "");

  return highlightSearchText(searchText.value, escapeHtml(name));
};

const getFavouriteDescription = (favourite: Favourite) => {
  return favourite.Type === 0
    ? mapParams(favourite.Client!.Parameters)
    : mapParams(favourite.Project!.Parameters);
};

const mapParams = (param: object[]) => {
  return param
    .map((p) =>
      p.Instance
        ? `${p.Instance.Key}: ${p.Instance.Value}`
        : mapParams(p.ListTitle),
    )
    .flat(2)
    .join(", ");
};

const deleteFromFavourites = async (favourite: Favourite) => {
  if (favourite.Type === 0) {
    await store.removeFavourites(favourite.Client!.Id, favourite.Type);
  } else {
    await store.removeFavourites(favourite.Project!.Id, favourite.Type);
  }
};

onMounted(() => {
  store.fetchFavourites(searchText.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (favourites.value && favourites.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(AppInput, {
              modelValue: searchText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
              class: "favourite-panel__filters-input",
              placeholder: _ctx.$t('search_favourite')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "favourite-panel__divider" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favouriteGroups.value, (group) => {
              return (_openBlock(), _createElementBlock("section", {
                key: group.type,
                class: "favourite-panel__group"
              }, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t(group.titleKey)) + ": ", 1),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (favourite, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${favourite.Type}-${favourite.Client?.Id || favourite.Project?.Id}`,
                      class: "favourite-panel__body-item"
                    }, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(index + 1) + ". ", 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          to: {
                    query: {
                      page: favourite.Type === 0 ? 'client' : 'project',
                      id:
                        favourite.Type === 0
                          ? favourite.Client?.Id
                          : favourite.Project?.Id,
                    },
                  },
                          class: _normalizeClass(["favourite-panel__body-item-text-name", {
                    'favourite-panel__body-item-text-name--remove-hovered':
                      hoveredRemoveFavourite.value === favourite,
                  }])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              innerHTML: getFavouriteName(favourite)
                            }, null, 8, _hoisted_8)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(getFavouriteDescription(favourite)), 1)
                      ]),
                      _createVNode(AppTooltip, {
                        class: "favourite-panel__body-item-icon",
                        text: _ctx.$t('favourite_remove'),
                        onMouseenter: ($event: any) => (hoveredRemoveFavourite.value = favourite),
                        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoveredRemoveFavourite.value = null))
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            name: "favourite",
                            width: "18px",
                            color: "#D05A4F",
                            "hover-color": "#979797",
                            cursor: "pointer",
                            onClick: ($event: any) => (deleteFromFavourites(favourite))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["text", "onMouseenter"])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128)),
            (searchText.value && !filteredFavourites.value?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('nothing_found')), 1))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('chat_favourite_empty')), 1))
  ]))
}
}

})